  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_TrackTransferService = {
  wu_tracktransfer
};
//----------------------------------------------------------------------------------------------------
function wu_tracktransfer(reqData) {
  const methName = "wu_tracktransfer ";
  let localUrl   = "";
  if(api.isCaptchaEnabled){ localUrl = api.url + "/wbrestservices-1.0.0/wbservice/tracktransfer?codeno="+reqData.codeno+"&senderFirstName="+reqData.senderFirstName+"&senderLastName="+reqData.senderLastName+"&recaptchaVerify="+reqData.recaptchaVerify.replace(/"/g,""); }
  else                    { localUrl = api.url + "/wbrestservices-1.0.0/wbservice/tracktransfer?codeno="+reqData.codeno+"&senderFirstName="+reqData.senderFirstName+"&senderLastName="+reqData.senderLastName; }

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getgetAppStats(api.webappENV),(),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
      "recaptchaVerify"             : reqData.recaptchaVerify ? reqData.recaptchaVerify.replace(/"/g,"") : "",
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {

  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
